import { Translate } from 'i18n';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { IArticle } from 'students/api/articles/types';

interface IProps {
  article: IArticle;
  onClose: () => void;
}

const WhatsNewItem: FC<IProps> = ({ article, onClose }) => {
  const history = useHistory();

  const formattedDate = new Intl.DateTimeFormat('en', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  }).format(new Date(article.publishedAt));

  const handleClick = () => {
    onClose();
    history.push(`/articles/${article.id}`);
  };

  return (
    <li className="ln-group">
      <button
        type="button"
        onClick={handleClick}
        className="ln-w-full ln-text-left ln-cursor-pointer ln-overflow-hidden ln-border-0 ln-bg-transparent hover:ln-bg-grey-light ln-p-0 ln-block"
      >
        {article.imageURL && (
          <img
            src={article.imageURL}
            alt=""
            className="ln-w-full ln-h-48 ln-object-cover"
          />
        )}

        <div className="ln-p-4 ln-relative">
          <div className="ln-flex ln-items-center ln-gap-2 ln-mb-2">
            {article.unread && (
              <span className="ln-text-[10px] ln-font-bold ln-px-2 ln-py-0.5 ln-rounded-full ln-bg-[#e1ff6a] ln-text-[#0b1420] ln-uppercase ln-tracking-wide ln-shrink-0">
                <Translate
                  str="frontend.whats_new.new_tag"
                  params={{ defaultValue: 'NEW' }}
                />
              </span>
            )}
            <time className="ln-text-xs ln-text-gray-500 ln-font-normal">
              {formattedDate}
            </time>
          </div>

          <h3 className="ln-text-base ln-font-bold ln-text-gray-900 ln-mb-1.5 ln-leading-snug">
            {article.title}
          </h3>

          {article.excerpt && (
            <div
              className="ln-relative ln-overflow-hidden"
              style={{ maxHeight: '3.6rem' }}
            >
              <p className="ln-text-sm ln-text-gray-500 ln-leading-relaxed">
                {article.excerpt}
              </p>
              <div className="ln-absolute ln-bottom-0 ln-left-0 ln-right-0 ln-h-8 ln-bg-gradient-to-t ln-from-white group-hover:ln-from-grey-light ln-to-transparent" />
            </div>
          )}

          {/* Read more — slides up + fades in on hover */}
          <div className="ln-absolute ln-bottom-4 ln-left-0 ln-right-0 ln-flex ln-justify-center ln-translate-y-3 ln-opacity-0 group-hover:ln-translate-y-0 group-hover:ln-opacity-100 ln-transition-all ln-duration-200 ln-ease-out ln-pointer-events-none">
            <span className="ln-bg-white ln-rounded-full ln-px-7 ln-py-2.5 ln-font-bold ln-text-sm ln-text-gray-900 ln-shadow-[0_4px_16px_rgba(0,0,0,0.12)]">
              <Translate
                str="frontend.whats_new.read_more"
                params={{ defaultValue: 'Read more' }}
              />
            </span>
          </div>
        </div>
      </button>
    </li>
  );
};

export default WhatsNewItem;
